import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { CHECKOUT_ESENCIAL, CHECKOUT_PREMIUM } from '../data/content';
import { trackPixelEvent } from '../utils/metaPixel';
const options = [{
  emoji: '📘',
  name: 'Mega Pack Esencial',
  price: '$19.990 ARS',
  value: 19990,
  url: CHECKOUT_ESENCIAL,
  featured: false
}, {
  emoji: '⭐',
  name: 'Pack Premium',
  price: '$27.990 ARS',
  value: 27990,
  url: CHECKOUT_PREMIUM,
  featured: true
}];
const trust = ['Garantía 7 días', 'Pago seguro', 'Acceso inmediato', 'Mercado Pago'];
export function FinalCta() {
  return <section className="w-full bg-ink py-20 md:py-28" aria-labelledby="cierre-title" data-id="element-46" data-mp="1t1myhvc4nr2r">
      <div className="mx-auto max-w-content px-5 md:px-8" data-id="element-47" data-mp="1o3lijja007vi">
        <h2 id="cierre-title" className="max-w-3xl text-4xl font-extrabold leading-[1.05] tracking-tightest text-white md:text-6xl" data-id="element-48" data-mp="223mgapuyuz6r">
          La próxima consulta puede ser diferente.
        </h2>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-white/65" data-id="element-49" data-mp="n6495hoebgir">
          Elegí tu pack y empezá a trabajar con un sistema — no con improvisación.
        </p>

        <div className="mt-12 grid gap-4 sm:grid-cols-2" data-id="element-50" data-mp="x3s70ghat455">
          {options.map(option => <a key={option.name} href={option.url} onClick={() => trackPixelEvent('InitiateCheckout', {
          content_name: option.name,
          value: option.value,
          currency: 'ARS'
        })} className={['group flex h-full flex-col rounded-2xl p-6 transition-colors duration-150 ease-out md:p-8', option.featured ? 'bg-accent hover:bg-accent-dark' : 'bg-white/[0.06] ring-1 ring-white/15 hover:bg-white/[0.1]'].join(' ')} data-id="element-51" data-mp="122vd8490lgep">
              <p className="flex items-center gap-2 text-sm font-bold uppercase tracking-[0.14em] text-white/70" data-id="element-52" data-mp="1tuko9hfyx28i">
                <span aria-hidden="true" className="text-base" data-id="element-53" data-mp="3qux8wj3i3syh">
                  {option.emoji}
                </span>
                {option.name}
              </p>
              <p className="mt-3 text-3xl font-extrabold tracking-tight text-white md:text-4xl" data-id="element-54" data-mp="3imsc96fkpa6">
                {option.price}
              </p>
              <p className="mt-auto flex items-center gap-2 pt-6 text-sm font-bold text-white" data-id="element-55" data-mp="3uufulh35c82d">
                Comprar ahora
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-56" data-mp="8h7j7hzslwly" />
              </p>
            </a>)}
        </div>

        <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-2" data-id="element-57" data-mp="ifnabkytl5vg">
          {trust.map(item => <li key={item} className="flex items-center gap-1.5 text-sm font-medium text-white/55" data-id="element-58" data-mp="2o83uovexb7s7">
              <CheckIcon className="h-4 w-4 text-accent" strokeWidth={3} aria-hidden="true" data-id="element-59" data-mp="2k81r2gpmo4aa" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}